import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';

import { accountsSelectors } from 'app-components/flux/accounts';
import { categoriesSelectors } from 'app-components/flux/categories';

import store from 'app-components/utils/redux-store';

const loadTestTransactionYears = (years) => {
  const transactions = [];
  const now = DateTime.local().startOf('day').plus({ days: 1 });
  const categories = categoriesSelectors.getResourcesById(store.getState()).toList();
  const categoriesNum = categories.size;
  const accounts = accountsSelectors.getCashAccounts(store.getState()).toList();
  const accountsNum = accounts.size;
  const transactionsNum = 7000;
  const payees = years * 50;
  const days = years * 365;
  for (let index = 1; index < transactionsNum; index++) {
    const cpId = uuidv4();
    const daysAgo = Math.random() * days;
    const postedOn = now.minus({ days: daysAgo }).toISODate();
    const category = categories.get(index % categoriesNum);
    const isBill = category.type === 'EXPENSE' && daysAgo % 30 === 1;
    const isSubscription = category.type === 'EXPENSE' && daysAgo % 30 === 2;
    const amountValue = index + Math.random().toFixed(2);
    const amount = category.type === 'EXPENSE' ? -amountValue : amountValue;

    transactions.push({
      clientId: cpId,
      source: 'QCS_REFRESH',
      accountId: accounts.get(index % accountsNum).id,
      postedOn,
      payee: `Payee ${index % payees} test${isBill ? ' myBill' : ''}${isSubscription ? ' mySubscription' : ''}`,
      coa: {
        type: 'CATEGORY',
        id: categories.get(index % categoriesNum).id,
      },
      amount,
      state: 'CLEARED',
      matchState: 'NOT_MATCHED',
      cpData: {
        id: cpId,
        cpPendingId: cpId,
        postedOn,
        txnOn: postedOn,
        amount,
        payee: `Payee ${index % payees} test${isBill ? ' myBill' : ''}${isSubscription ? ' mySubscription' : ''}`,
        inferredPayee: String(index % payees),
        inferredCoa: {
          type: 'CATEGORY',
          id: category.id,
        },
        cpCategoryId: '2002',
      },
      type: 'CASH_FLOW',
      isBill,
      isSubscription,
    });
  }
  return transactions;
};

export default loadTestTransactionYears;
